import React from 'react';
import { capitalize } from "../../../../../../Utils";

const Head = ({ onSortChange, params }) => {
    let th = params.map(param => <th onClick={() => onSortChange(param)} key={param}>{capitalize(param)}</th>);

    return (
        <thead>
            <tr>{th}</tr>
        </thead>
    )
};

export default Head;



// WEBPACK FOOTER //
// ./src/scenes/BidderError/components/Table/components/Head/index.js